import React, {Fragment, useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';

// controls
import Table, {Column} from '../../table'
//helpers
import {formatDatetime, getCategoryFilterType, getNameEntity, getNameVehicle, useHandleExportReport} from 'Modules/reports/views/main/components/reportsTab/helper';

//hooks
import {useSidePanelMap, useTableReport} from 'Core/hooks';
//actions
import {clearRedux, reportsMainGenerateEvents, reportsMainGenerateReportUpdate} from 'Redux/actions'

// styles
import './alertLogReport.scss';
import moment from "moment";
import AddressLandmark from "Modules/reports/views/main/components/reportsTab/.components/addressLandmark";


const AlertLogReport = (props) => {
    const {messages, report} = props;
    const {data, filters, summary, loadingSummary, timeZone} = report;
    const {filterEntity, otherFilters, startRange, endRange} = filters;

    const [SideMapComponent, onToggleSideMap] = useSidePanelMap();
    const [unitDriverSelected, setUnitDriverSelected] = useState();
    const [currentRowsPerPage, setCurrentRowsPerPage] = useState(10);
    const [currentNewSortField, setCurrentNewSortField] = useState("deviceId");
    const [currentNewSortOrder, setCurrentNewSortOrder] = useState("asc");

    const exportHandler = useHandleExportReport(report)

    const loadingCreateLandMark = useSelector(state => state.vehicleLandMarkRedux.loadingCreateLandMark)
    const createLandMarkResult = useSelector(state => state.vehicleLandMarkRedux.createLandMarkResult)

    const reportRef = useRef();
    const dispatch = useDispatch()
    useEffect(() => {
        if (report) {
            const newReport = JSON.parse(JSON.stringify(report));
            // to keep the reference to the units selected
            reportRef.current = newReport;
        }
    }, [JSON.stringify(report)]);

    useEffect(() => {
        if (!loadingCreateLandMark && createLandMarkResult) {
            dispatch(reportsMainGenerateReportUpdate(report, currentPage, currentRowsPerPage, currentNewSortField, currentNewSortOrder))
            dispatch(clearRedux("LANDMARK", {"createLandMarkResult": null}));
        }

    }, [loadingCreateLandMark, createLandMarkResult])
    const unitHasData = noData => !noData
    const onChangeExpandable = (unit) => {
        if(unitHasData(unit.noData)) {
            let events = {
                data: [],
                filters: {
                    filterType: getCategoryFilterType(filterEntity),
                    filterArray: unit,
                    page: 1,
                    rowsPerPage: 10,
                    sortField: 'eventDate',
                    otherFilters
                }
            }
            dispatch(reportsMainGenerateEvents(report, events))
        }
    }

    const extractedData = (data) => {
        const mapCount = data.reduce((acc, item) => {
                let group = formatDatetime(item.alertTime, 'MMMM/D/YYYY', timeZone)
                acc.set(group, (acc.get(group) || 0) + 1)
                return acc
            }, new Map()
        )

        const contentMapEntries = [...mapCount.entries()];

        let contentIds = []
        for (const entry of contentMapEntries) {
            contentIds.push({date: entry[0].toString(), count: entry[1]})
        }
        return contentIds;
    }

    const renderExpandableRow = (row) => {

        const items = row.noData? [{}] : (summary?.items.length ? extractedData(summary?.items) : [{}]);
        return (
            <div style={{width: '100%'}}>
                <Table
                    hideHeader
                    loading={loadingSummary}
                    data={items}
                    totalItems={row.noData ? 1 : (summary?.total || 1)}
                    onChangedPage={(page, rowsPerPage, sortField, sortOrder) => {
                        let events = {
                            data: [],
                            filters: {filterType: getCategoryFilterType(filterEntity), filterArray: row, page, rowsPerPage, sortField, sortOrder, otherFilters}
                        }
                        dispatch(reportsMainGenerateEvents(report, events))
                    }}
                    serverSideTable={true}
                    hideNumberOfRows={true}
                    hiddenPagination={false}
                    classNameColumns="report-column-events-expandible table-day-timesheet-tr"
                    noDataMessage={messages["generatedReport_noEvents"]}
                    numberofRows={10}
                    centerPagination
                    noData={row.noData}
                >
                    <Column noSorting>
                        {(element) => {
                            const filter = row.noData ? [{}]: 
                                            (
                                                summary?.items.length ? summary?.items.filter((res) => formatDatetime(res.alertTime, 'MMMM/D/YYYY', timeZone) === element.date) : [{}]
                                            );

                            const localTimeEnd = element.date;
                            
                            return (
                                <div>
                                    <strong className="landmark-set">{row.noData? "" : localTimeEnd}</strong>
                                    <Table
                                        data={filter}
                                        noDataMessage={messages["reportsMainRT_noTripsAvailable"]}
                                        hideNumberOfRows={true}
                                        hiddenPagination={true}
                                        classNameColumns={'report-sub-events-columns detail-day-moving-tr'}
                                    >
                                        <Column label={messages["generatedReport_timeAndDate"]} field="alertTime" noSorting>
                                            {(element) => {
                                                return (
                                                    <div>
                                                        <span className="speed-report-stacked">{element.alertTime && formatDatetime(element.alertTime, "h:mm A", timeZone)}</span>
                                                        <span
                                                            className="speed-reportstacked speed-report-event-date">{element.alertTime && formatDatetime(element.alertTime, "MMM D", timeZone)}</span>
                                                    </div>
                                                )
                                            }}
                                        </Column>
                                        <Column label={messages["generatedReport_address"]} field="address" noSorting>
                                            {(element) => {
                                                return (
                                                    <div>
                                                        <AddressLandmark onToggleSideMap={onToggleSideMap} messages={messages} element={{address: element.address}}/>
                                                    </div>
                                                )
                                            }}
                                        </Column>
                                        <Column label={getNameEntity(filterEntity  === 'Driver' ? 'Unit' : 'Driver', messages)} field="driverName" noSorting>
                                            {(element) => {
                                                return (
                                                    <div>
                                                        <span>{element.driverName || messages["generatedReport_notAssigned"] } </span>
                                                    </div>
                                                )
                                            }}
                                        </Column>
                                        <Column label={messages["generatedReport_contacts"]} field="contacts" noSorting>
                                            {(element) => {
                                                return (
                                                    <div>
                                                        <span>{element.contacts}</span>
                                                    </div>
                                                )
                                            }}
                                        </Column>
                                        <Column label={messages["generatedReport_alertType"]} field="alertType" noSorting>
                                            {(element) => {
                                                return (
                                                    <div>
                                                        <span>{element.alertType}</span>
                                                    </div>
                                                )
                                            }}
                                        </Column>
                                        <Column label={messages["generatedReport_alertDetail"]} field="alertDetail" noSorting>
                                            {(element) => {
                                                return (
                                                    <div>
                                                        <span>{element.alertDetail}</span>
                                                    </div>
                                                )
                                            }}
                                        </Column>
                                    </Table>
                                </div>
                            );
                        }}
                    </Column>
                    <Column>
                        {() => { return '' }}
                    </Column>
                </Table>
            </div>
        )
    }
    let parametersTable = useTableReport({
        data: data.items,
        report,
        messages,
        hideHeader: true,
        renderExpandableRow,
        onChangeExpandable,
        propertyToShowExpandable: 'id',
        classNameColumns: 'start-stop-idle-main-table'
    });
    return (
        <Fragment>
            <Table
                {...parametersTable}
                {...exportHandler}
            >
                <Column label="Day" field="label">
                    {(element) => {
                        return (
                            <div>
                                <span>
                                  <span><strong>{getNameEntity(filterEntity, messages)}:</strong> {element.idLabel} </span>
                                </span>
                            </div>
                        );
                    }}
                </Column>
                <Column label={messages['generatedReport_totalIdleTime']} field="label">
                    {(element) => {
                        const localTimeStart = moment.utc(startRange).local().format();
                        const localTimeEnd = moment.utc(endRange).local().format();
                        return (
                            <div>
                                <span>
                                  <span>
                                    <strong>{messages['generatedReport_range']}:</strong> {` ${formatDatetime(localTimeStart, "MMMM D, YYYY h:mm A", timeZone)} - ${formatDatetime(localTimeEnd, "MMMM D, YYYY h:mm A", timeZone)}`}
                                  </span>
                                </span>
                            </div>
                        );
                    }}
                </Column>
            </Table>
            <SideMapComponent hiddenButton hiddenSearchMap/>
        </Fragment>
    );
}

export default AlertLogReport;
